import React, { useEffect, useState, useRef, useCallback } from 'react';

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Debug"] = 0] = "Debug";
    LogLevel[LogLevel["Info"] = 1] = "Info";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Error"] = 3] = "Error";
    LogLevel[LogLevel["Fatal"] = 4] = "Fatal";
})(LogLevel || (LogLevel = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var isFirst = function (index) { return index === 0; };
var isLast = function (index, array) {
    return index === array.length - 1;
};

function classNames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        if (!arg) {
            continue;
        }
        if (typeof arg === "string" || typeof arg === "number") {
            classes.push(String(arg));
        }
        else if (Array.isArray(arg)) {
            classes.push(classNames.apply(void 0, arg));
        }
        else if (typeof arg === "object") {
            for (var key in arg) {
                if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
                    classes.push(key);
                }
            }
        }
    }
    return classes.join(" ");
}

var isClient = function () { return typeof window !== "undefined"; };

var downloadBlob = function (blob, filename) {
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
};

var formatFileSize = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0)
        return "0 Bytes";
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

function hashString(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
        hash = (hash * 33) ^ str.charCodeAt(i);
    }
    return hash >>> 0;
}

var openUrlInNewWindow = function (url) { return window.open(url, "_blank"); };

var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
        this.writeString = function (key, value) {
            return window.localStorage.setItem(key, value !== null && value !== void 0 ? value : "");
        };
        this.readString = function (key) { var _a; return (_a = window.localStorage.getItem(key)) !== null && _a !== void 0 ? _a : undefined; };
        this.writeObject = function (key, value) {
            return window.localStorage.setItem(key, JSON.stringify(value));
        };
        this.readObject = function (key) {
            var serializedValue = window.localStorage.getItem(key);
            if (serializedValue === "undefined") {
                return undefined;
            }
            return serializedValue ? JSON.parse(serializedValue) : undefined;
        };
        this.removeObject = function (key) {
            window.localStorage.removeItem(key);
        };
        this.clearObjects = function () { return window.localStorage.clear(); };
    }
    return LocalStorageService;
}());

var isNullOrUndefined = function (value) {
    return value === null || value === undefined;
};
var isObject = function (obj) { return obj && typeof obj === "object"; };
var deepMerge = function (obj1, obj2) {
    if (!isObject(obj1)) {
        return obj2;
    }
    if (!isObject(obj2)) {
        return obj1;
    }
    var keys = new Set(__spreadArray(__spreadArray([], Object.keys(obj1), true), Object.keys(obj2), true));
    var result = {};
    keys.forEach(function (key) {
        var val1 = obj1[key];
        var val2 = obj2[key];
        if (Array.isArray(val1) && Array.isArray(val2)) {
            result[key] = val2 === undefined ? val1 : val2;
        }
        else if (isObject(val1) && isObject(val2)) {
            result[key] = deepMerge(val1, val2);
        }
        else {
            result[key] = val2 === undefined ? val1 : val2;
        }
    });
    return result;
};
var jsonClone = function (obj) {
    return !!obj ? JSON.parse(JSON.stringify(obj)) : undefined;
};
function jsonEquals(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}

var toString = function (value) {
    return value ? value.toString() : "";
};
var replaceAll$1 = function (input, value, replaceWith) {
    return input.split(value).join(replaceWith);
};
var replacePlaceholders = function (value, placeholders) {
    return Object.entries(placeholders).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        return replaceAll$1(acc, "{{".concat(key, "}}"), toString(value));
    }, value);
};

function parseObjectPosition(position) {
    if (!position) {
        return {
            top: "",
            right: "",
            bottom: "",
            left: "",
        };
    }
    var defaults = {
        top: "auto",
        right: "auto",
        bottom: "auto",
        left: "auto",
    };
    if (position.trim() === "center" || position.trim() === "center center") {
        return defaults;
    }
    var positionParts = position.split(" ");
    var result = __assign({}, defaults);
    var cursor = 0;
    while (cursor < positionParts.length) {
        var key = positionParts[cursor]; // 'right', 'left', 'top', 'bottom', 'center'
        if (key === "center") {
            if (cursor === 0 && positionParts.length === 1) {
                result["top"] = defaults.top;
                result["right"] = defaults.right;
                result["bottom"] = defaults.bottom;
                result["left"] = defaults.left;
                return result;
            }
            if (positionParts.includes("right") || positionParts.includes("left")) {
                result["top"] = defaults.top;
                result["bottom"] = defaults.bottom;
            }
            else {
                result["right"] = defaults.right;
                result["left"] = defaults.left;
            }
            cursor++;
            continue;
        }
        var value = positionParts[cursor + 1];
        if (key && value) {
            switch (key) {
                case "top":
                case "right":
                case "bottom":
                case "left":
                    result[key] = value;
                    break;
            }
        }
        cursor += 2;
    }
    return result;
}
function parseObjectPositionResponsive(position) {
    var _a, _b, _c, _d, _e;
    return {
        xs: parseObjectPosition((_a = position.xs) !== null && _a !== void 0 ? _a : ""),
        sm: parseObjectPosition((_b = position.sm) !== null && _b !== void 0 ? _b : ""),
        md: parseObjectPosition((_c = position.md) !== null && _c !== void 0 ? _c : ""),
        lg: parseObjectPosition((_d = position.lg) !== null && _d !== void 0 ? _d : ""),
        xl: parseObjectPosition((_e = position.xl) !== null && _e !== void 0 ? _e : ""),
    };
}

var range = function (count) {
    var result = [];
    for (var i = 0; i < count; i++) {
        result.push(i);
    }
    return result;
};

var getResponsiveValue = function (breakpoint, value) {
    if (!value) {
        return undefined;
    }
    if (typeof value === "object") {
        return value[breakpoint];
    }
    return value;
};

var ensureTailingSlash = function (value) {
    return value.endsWith("/") ? value : value + "/";
};
var trimEnd = function (value, char) {
    if (!value.endsWith(char)) {
        return value;
    }
    return trimEnd(value.substring(0, value.length - 1), char);
};
var trimStart = function (value, char) {
    if (!value.startsWith(char)) {
        return value;
    }
    return trimStart(value.substring(1), char);
};
var trimChar = function (value, char) {
    return trimStart(trimEnd(value, char), char);
};
var toTitleCase = function (string) {
    var str = string.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
};
var extractNumber = function (string) { var _a; return (_a = string.match(/\d+/g)) === null || _a === void 0 ? void 0 : _a[0]; };
var isInt = function (value) { var _a; return (_a = value === null || value === void 0 ? void 0 : value.match(/^\d+$/)) !== null && _a !== void 0 ? _a : false; };
var insensitiveEquals = function (value1, value2) { return (value1 === null || value1 === void 0 ? void 0 : value1.trim().toLocaleLowerCase()) === (value2 === null || value2 === void 0 ? void 0 : value2.trim().toLocaleLowerCase()); };
var replaceAll = function (input, value, replaceWith) {
    return input.split(value).join(replaceWith);
};
var removeNewLines = function (value) {
    return replaceAll(replaceAll(value, "\n", ""), "\r", "");
};
var truncateText = function (value, length, fill) {
    if (fill === void 0) { fill = "..."; }
    if (!value || value.length <= length) {
        return value;
    }
    return value.substring(0, length) + fill;
};

var setCssVar = function (varName, value) {
    var _a;
    return _a = {},
        _a[varName] = value !== null && value !== void 0 ? value : "",
        _a;
};
var normalizePxSize = function (size) {
    function isNumber(value) {
        var regex = /^-?\d+(\.\d+)?$/;
        return regex.test(value);
    }
    if (typeof size === "number") {
        return "".concat(size, "px");
    }
    if (typeof size === "string" && isNumber(size)) {
        return "".concat(size, "px");
    }
    return size;
};

var makeAbsoluteUrl = function (path) {
    return "".concat(trimEnd(window.location.origin, "/"), "/").concat(trimStart(path, "/"));
};
function serializeQueryString(obj) {
    var queryString = "";
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) {
            if (queryString.length > 0) {
                queryString += "&";
            }
            queryString += key + "=" + encodeURIComponent(obj[key]);
        }
    }
    return queryString;
}
var buildUrl = function (path, query) {
    var queryString = serializeQueryString(query);
    return queryString ? "".concat(path, "?").concat(queryString) : path;
};
function deserializeQueryString(queryString) {
    var obj = {};
    var pairs = queryString.substring(1).split("&");
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1] || "");
        if (obj[key]) {
            if (Array.isArray(obj[key])) {
                obj[key].push(value);
            }
            else {
                obj[key] = [obj[key], value];
            }
        }
        else {
            obj[key] = value;
        }
    }
    return obj;
}
var getQueryParameter = function (name, location) {
    if (location === void 0) { location = window.location; }
    var urlParams = deserializeQueryString(location.search);
    return urlParams[name];
};
var updateQueryParameters = function (queryString, params) {
    var queryParams = deserializeQueryString(queryString);
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        queryParams[key] = value;
    }
    return serializeQueryString(queryParams);
};

var newUuid = function () {
    var template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    return template.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

var cssVar = function (varName) { return "var(".concat(varName, ")"); };

var getGradientColorVar = function (color, gradient) { return "--wp-theme-color-".concat(color, "-").concat(gradient); };
var getColorVar = function (color) { return "--wp-theme-color-".concat(color); };
var getColorVarContrast = function (color) {
    return "--wp-theme-color-".concat(color, "-contrast");
};
var getColorVarLight = function (color) {
    return "--wp-theme-color-".concat(color, "-light");
};
var getColorVarDark = function (color) {
    return "--wp-theme-color-".concat(color, "-dark");
};
var getThemeColorVar = function (color, variant) {
    switch (variant) {
        case "contrast":
            return getColorVarContrast(color);
        case "light":
            return getColorVarLight(color);
        case "dark":
            return getColorVarDark(color);
        default:
            return getColorVar(color);
    }
};
var setColorVar = function (varName, color) {
    return color ? setCssVar(varName, cssVar(getColorVar(color))) : undefined;
};
var setColorVarContrast = function (varName, color) {
    return color ? setCssVar(varName, cssVar(getColorVarContrast(color))) : undefined;
};
var setColorVarLight = function (varName, color) {
    return color ? setCssVar(varName, cssVar(getColorVarLight(color))) : undefined;
};
var setColorVarDark = function (varName, color) {
    return color ? setCssVar(varName, cssVar(getColorVarDark(color))) : undefined;
};
var setThemeColorVar = function (varName, color, variant) {
    return color
        ? setCssVar(varName, cssVar(getThemeColorVar(color, variant)))
        : undefined;
};

var getTextSizeVar = function (variant) {
    return "--wp-text-".concat(variant, "-size");
};
var getTextLineHeightVar = function (variant) {
    return "--wp-text-".concat(variant, "-line-height");
};
var getTextLetterSpacingVar = function (variant) {
    return "--wp-text-".concat(variant, "-spacing");
};
var getTextWeightVar = function (variant) {
    return "--wp-text-".concat(variant, "-weight");
};
var getTextFontVar = function (variant) {
    return "--wp-text-".concat(variant, "-font");
};

var ThemeVariablesPrefixes = {
    Color: "wp-theme-color",
    Text: "wp-theme-text",
    Font: "wp-theme-font",
};

var themeColorVariables = function (palette, name, color) {
    var _a;
    var _b, _c, _d, _e;
    return (_a = {},
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name)] = color.default,
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-contrast")] = (_b = color.contrast) !== null && _b !== void 0 ? _b : "",
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-focus")] = (_c = color.focus) !== null && _c !== void 0 ? _c : "",
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-light")] = (_d = color.light) !== null && _d !== void 0 ? _d : "",
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-dark")] = (_e = color.dark) !== null && _e !== void 0 ? _e : "",
        _a);
};
var themeScaledColorVariables = function (palette, name, color) {
    var _a;
    return (_a = {},
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-10")] = color[10],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-20")] = color[20],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-30")] = color[30],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-40")] = color[40],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-50")] = color[50],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-60")] = color[60],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-70")] = color[70],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-80")] = color[80],
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-").concat(name, "-90")] = color[90],
        _a);
};
var themeTextColorVariables = function (palette, colors) {
    var _a;
    return (_a = {},
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-text-default")] = colors.default,
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-text-caption")] = colors.caption,
        _a);
};
var themeSidebarColorValues = function (palette, colors) {
    var _a;
    return (_a = {},
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-sidebar-background")] = colors.background,
        _a["--".concat(ThemeVariablesPrefixes.Color, "-").concat(palette, "-sidebar-content")] = colors.content,
        _a);
};
var buildBaseColors = function (colors, palette) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, themeColorVariables(palette, "primary", colors.primary)), themeColorVariables(palette, "secondary", colors.secondary)), themeColorVariables(palette, "info", colors.info)), themeColorVariables(palette, "success", colors.success)), themeColorVariables(palette, "error", colors.error)), themeColorVariables(palette, "warning", colors.warning)), themeColorVariables(palette, "background", colors.background)), themeColorVariables(palette, "paper", colors.paper)), themeColorVariables(palette, "paperNegative", colors.paperNegative)), themeColorVariables(palette, "white", colors.paper)), themeColorVariables(palette, "black", colors.paper)), themeColorVariables(palette, "border", colors.border)), themeScaledColorVariables(palette, "grey", colors.grey)), themeSidebarColorValues(palette, colors.sidebar)), themeTextColorVariables(palette, colors.text));
};
var buildThemePaletteVariables = function (palette) {
    return __assign(__assign({}, buildBaseColors(palette.light, "light")), (palette.dark ? buildBaseColors(palette.dark, "dark") : {}));
};

var textVar = function (suffix) { return "--".concat(ThemeVariablesPrefixes.Text, "-").concat(suffix); };
var fontVar = function (suffix) { return "--".concat(ThemeVariablesPrefixes.Font, "-").concat(suffix); };
var fontWeightVariables = function (weights) {
    var _a;
    return (_a = {},
        _a[textVar("extraLight")] = weights.extraLight,
        _a[textVar("light")] = weights.light,
        _a[textVar("regular-w")] = weights.regular,
        _a[textVar("medium-w")] = weights.medium,
        _a[textVar("semiBold-w")] = weights.semiBold,
        _a[textVar("bold-w")] = weights.bold,
        _a[textVar("extraBold-w")] = weights.extraBold,
        _a);
};
var themeTextVariant = function (name, variant) {
    var _a;
    var _b, _c;
    return (_a = {},
        _a[textVar("".concat(name, "-s"))] = variant.size,
        _a[textVar("".concat(name, "-h"))] = variant.height,
        _a[textVar("".concat(name, "-w"))] = variant.weight,
        _a[textVar("".concat(name, "-st"))] = (_b = variant.style) !== null && _b !== void 0 ? _b : "normal",
        _a[textVar("".concat(name, "-f"))] = (_c = variant.font) !== null && _c !== void 0 ? _c : "inherit",
        _a);
};
var typographyVariantVariables = function (variants) { return (__assign({}, Object.entries(variants).reduce(function (obj, _a) {
    var key = _a[0], value = _a[1];
    return (__assign(__assign({}, obj), themeTextVariant(key, value)));
}, {}))); };
var fontFamilyVariables = function (name, font) {
    var _a;
    return (_a = {},
        _a[fontVar(name)] = font.family,
        _a);
};
var fontFamiliesVariables = function (fonts) {
    var _a;
    return (__assign(__assign({}, fontFamilyVariables("default", fonts.default)), fontFamilyVariables("secondary", (_a = fonts.secondary) !== null && _a !== void 0 ? _a : fonts.default)));
};
var buildThemeTypographyVariables = function (typography) { return (__assign(__assign(__assign({}, fontWeightVariables(typography.weights)), typographyVariantVariables(typography.variants)), fontFamiliesVariables(typography.fonts))); };

var buildThemeVariables = function (theme) {
    return __assign(__assign({}, buildThemePaletteVariables(theme.palette)), buildThemeTypographyVariables(theme.typography));
};

var buildThemeColor = function (color, mode) { return "\n".concat(getColorVar(color), ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, ");\n").concat(getColorVarContrast(color), ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, "-contrast);\n--").concat(ThemeVariablesPrefixes.Color, "-").concat(color, "-focus: var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, "-focus);\n").concat(getColorVarLight(color), ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, "-light);\n").concat(getColorVarDark(color), ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, "-dark);\n--").concat(ThemeVariablesPrefixes.Color, "-text-").concat(color, ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(color, ");\n"); };
var buildScaledThemeColor = function (color, mode) {
    return [10, 20, 30, 40, 50, 60, 70, 80, 90]
        .map(function (x) {
        return "".concat(getGradientColorVar(color, x), ": var(--").concat(ThemeVariablesPrefixes.Color, "-").concat(mode, "-").concat(color, "-").concat(x, ");");
    })
        .join("\n");
};
var mainColors = [
    "primary",
    "secondary",
    "info",
    "success",
    "error",
    "warning",
    // "background",
    "paper",
    "paperNegative",
    "white",
    "black",
    // "border",
];
var gradientColors = ["grey"];
var buildThemeColors = function (mode) { return "\n".concat(mainColors.map(function (x) { return buildThemeColor(x, mode); }).join("\n"), "\n").concat(gradientColors.map(function (x) { return buildScaledThemeColor(x, mode); }).join("\n"), "\n"); };
var buildStylesheet = function (theme) {
    var variables = buildThemeVariables(theme);
    return "\n:root {\n  ".concat(Object.keys(variables)
        .map(function (key) { return "".concat(key, ": ").concat(variables[key], ";"); })
        .join("\n"), "\n}\n\n:root,\n:root.light,\n:root[data-theme=\"light\"] {\n  ").concat(buildThemeColors("light"), "\n}\n\n:root.dark,\n:root[data-theme=\"dark\"] {\n  ").concat(buildThemeColors("dark"), "\n}\n\n.root {\n}\n");
};
// export const useStylesheet = (theme: AppTheme) => {
//   const variables = useMemo(() => buildThemeVariables(theme), [theme])
//   return buildStylesheet(variables)
// }
var ThemeStyles = function (_a) {
    var theme = _a.theme; _a.excludeBaseStyles;
    var variables = buildThemeVariables(theme); // useMemo(() => buildThemeVariables(theme), [theme])
    return (
    // @ts-ignore
    React.createElement("style", { jsx: true, global: true }, "\n        :root {\n          ".concat(Object.keys(variables)
        .map(function (key) { return "".concat(key, ": ").concat(variables[key], ";"); })
        .join("\n"), "\n        }\n\n        :root,\n        :root.light,\n        :root[data-theme=\"light\"] {\n          ").concat(buildThemeColors("light"), "\n        }\n\n        :root.dark,\n        :root[data-theme=\"dark\"] {\n          ").concat(buildThemeColors("dark"), "\n        }\n\n        .root {\n        }\n      ")));
};

var extendBaseColor = function (color) {
    var _a;
    return (_a = {},
        _a[color] = {
            DEFAULT: cssVar(getColorVar(color)),
            contrast: cssVar(getColorVarContrast(color)),
            dark: cssVar(getColorVarDark(color)),
            light: cssVar(getColorVarLight(color)),
        },
        _a);
};
var gradients = [10, 20, 30, 40, 50, 60, 70, 80, 90];
var extendGradientColor = function (color) {
    var _a;
    return (_a = {},
        _a[color] = gradients.reduce(function (x, v) {
            x[v] = cssVar(getGradientColorVar(color, v));
            return x;
        }, {}),
        _a);
};
var extendThemeColors = function () { return ({
    colors: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, extendBaseColor("primary")), extendBaseColor("secondary")), extendBaseColor("info")), extendBaseColor("success")), extendBaseColor("warning")), extendBaseColor("error")), extendBaseColor("white")), extendBaseColor("black")), extendBaseColor("paper")), extendBaseColor("paperNegative")), extendGradientColor("grey")),
}); };

var sizes = [
    "body1",
    "body2",
    "body3",
    "caption1",
    "caption2",
    "caption3",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "label1",
    "label2",
    "label3",
];
var getFontSizes = function () {
    return sizes.reduce(function (x, v) {
        x[v] = cssVar(getTextSizeVar(v));
        return x;
    }, {});
};
var getLineHeights = function () {
    return sizes.reduce(function (x, v) {
        x[v] = cssVar(getTextLineHeightVar(v));
        return x;
    }, {});
};
var getLetterSpacings = function () {
    return sizes.reduce(function (x, v) {
        x[v] = cssVar(getTextLetterSpacingVar(v));
        return x;
    }, {});
};
var getWeights = function () {
    return sizes.reduce(function (x, v) {
        x[v] = cssVar(getTextFontVar(v));
        return x;
    }, {});
};
var getFonts = function () {
    return sizes.reduce(function (x, v) {
        x[v] = cssVar(getTextWeightVar(v));
        return x;
    }, {});
};
var extendFonts = function () { return ({
    fontSize: getFontSizes(),
    fontWeight: getWeights(),
    lineHeight: getLineHeights(),
    letterSpacing: getLetterSpacings(),
    fontFamily: getFonts(),
}); };

var extendTailwindTheme = function () { return (__assign(__assign({}, extendThemeColors()), extendFonts())); };

var invokeOperation = function (input, variables) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!variables) return [3 /*break*/, 2];
                return [4 /*yield*/, input.operation(variables)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [4 /*yield*/, input.operation()];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var useOperation = function (input) {
    var isAutoTriggerInvoked = React.useRef(false);
    var _a = React.useState({
        called: false,
        loading: false,
        completed: false,
    }), state = _a[0], setState = _a[1];
    var invoke = function (variables) { return __awaiter(void 0, void 0, void 0, function () {
        var operationId, result, e_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    isAutoTriggerInvoked.current = true;
                    operationId = newUuid();
                    setState({
                        called: true,
                        loading: true,
                        completed: false,
                        data: undefined,
                        error: undefined,
                        operationId: operationId,
                    });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, 4, 5]);
                    (_a = input.onStarted) === null || _a === void 0 ? void 0 : _a.call(input, variables);
                    return [4 /*yield*/, invokeOperation(input, variables)];
                case 2:
                    result = _e.sent();
                    setState({
                        called: true,
                        loading: false,
                        data: result,
                        error: undefined,
                        operationId: operationId,
                        completed: true,
                        success: true,
                    });
                    (_b = input.onSuccess) === null || _b === void 0 ? void 0 : _b.call(input, result);
                    return [2 /*return*/, result];
                case 3:
                    e_1 = _e.sent();
                    console.error("Error invoking operation", e_1);
                    setState({
                        called: true,
                        loading: false,
                        data: undefined,
                        error: e_1,
                        operationId: operationId,
                        completed: true,
                        success: false,
                    });
                    (_c = input.onError) === null || _c === void 0 ? void 0 : _c.call(input, e_1);
                    throw e_1;
                case 4:
                    (_d = input.onFinalized) === null || _d === void 0 ? void 0 : _d.call(input, variables);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!input.autoTrigger || isAutoTriggerInvoked.current) {
            return;
        }
        invoke().catch(function () { return null; });
    }, []);
    return {
        invoke: invoke,
        state: state,
    };
};

var empty = function () { return ({
    loading: false,
    faulted: undefined,
    success: undefined,
    error: undefined,
    operationId: undefined,
}); };
var loading = function (input) {
    var _a;
    return ({
        loading: true,
        faulted: undefined,
        success: undefined,
        error: undefined,
        data: input === null || input === void 0 ? void 0 : input.currentData,
        operationId: (_a = input === null || input === void 0 ? void 0 : input.operationId) !== null && _a !== void 0 ? _a : newUuid(),
    });
};
var triggered = function (input) { return ({
    input: input,
    loading: true,
    faulted: undefined,
    success: undefined,
    error: undefined,
}); };
var completed = function (data) { return ({
    loading: false,
    success: true,
    faulted: undefined,
    error: undefined,
    data: data,
}); };
var triggerCompleted = function (_a) {
    var data = _a.data, input = _a.input;
    return (__assign(__assign({}, completed(data)), { input: input }));
};
var failure = function (error) { return ({
    loading: false,
    success: false,
    faulted: true,
    error: error,
}); };
var triggerFailed = function (_a) {
    var error = _a.error, input = _a.input;
    return (__assign(__assign({}, failure(error)), { input: input }));
};
var idle = function () { return ({
    loading: false,
    success: undefined,
    error: undefined,
    faulted: undefined,
}); };
var running = function () { return ({
    loading: true,
    success: undefined,
    error: undefined,
    faulted: undefined,
}); };
var success = function () { return ({
    loading: false,
    success: true,
    error: undefined,
    faulted: undefined,
}); };
var faulted = function (error) { return ({
    loading: false,
    success: false,
    faulted: true,
    error: error,
}); };

function deepCompare(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}
/**
 * @deprecated Use useDebouncedValue instead
 */
function useDebounce(value, delay, options) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            var isChanged = (options === null || options === void 0 ? void 0 : options.deepCompare)
                ? !deepCompare(value, debouncedValue)
                : value !== debouncedValue;
            if (isChanged) {
                setDebouncedValue(value);
            }
        }, delay || 500);
        return function () {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}

function useDebouncedValue(value, delay) {
    if (delay === void 0) { delay = 500; }
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            var isChanged = !jsonEquals(value, debouncedValue);
            if (isChanged) {
                setDebouncedValue(jsonClone(value));
            }
        }, delay);
        return function () {
            clearTimeout(timer);
        };
    }, [JSON.stringify(value), delay]);
    return debouncedValue;
}

var useDebouncedCallback = function (_a) {
    var value = _a.value, callback = _a.callback, _b = _a.delay, delay = _b === void 0 ? 1000 : _b;
    var debouncedValue = useDebouncedValue(value, delay);
    var _c = useState(false), initialized = _c[0], setInitialized = _c[1];
    useEffect(function () {
        if (!initialized) {
            setInitialized(true);
            return;
        }
        callback(debouncedValue);
    }, [debouncedValue]);
};

/**
 * Hook used to detect clicks outside a component (or an escape key press). onTriggered function is triggered on `click` or escape `keyup` event.
 *
 */
function useDetectClickOutside(_a) {
    var onTriggered = _a.onTriggered, _b = _a.disableClick, disableClick = _b === void 0 ? false : _b, _c = _a.disableKeys, disableKeys = _c === void 0 ? false : _c, _d = _a.allowAnyKey, allowAnyKey = _d === void 0 ? false : _d, _e = _a.triggerKeys, triggerKeys = _e === void 0 ? [] : _e, _f = _a.excludedElements, excludedElements = _f === void 0 ? [] : _f;
    var ref = useRef(null);
    useEffect(function () {
        function handleClickOutside(event) {
            var _a;
            var target = event.target;
            if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !excludedElements.includes(target) &&
                !disableClick) {
                onTriggered(event);
            }
        }
        function handleKeyDown(event) {
            var key = event.key;
            if ((!disableKeys && triggerKeys.length === 0 && !allowAnyKey) ||
                (disableKeys && triggerKeys.length === 0) ||
                (triggerKeys.includes(key) && !disableKeys) ||
                (allowAnyKey && !disableKeys)) {
                onTriggered(event);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onTriggered,
        disableClick,
        disableKeys,
        allowAnyKey,
        triggerKeys,
        excludedElements,
    ]);
    return ref;
}

var useDidUpdate = function (fn, dependencies) {
    var mounted = useRef(false);
    useEffect(function () {
        if (mounted.current) {
            fn();
        }
        else {
            mounted.current = true;
        }
    }, dependencies);
};

var useElementSize = function (ref) {
    var _a = useState({
        scrollHeight: 0,
        scrollWidth: 0,
    }), size = _a[0], setSize = _a[1];
    useEffect(function () {
        var updateSize = function () {
            if (ref.current) {
                setSize({
                    scrollHeight: ref.current.scrollHeight,
                    scrollWidth: ref.current.scrollWidth,
                });
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return function () { return window.removeEventListener("resize", updateSize); };
    }, [ref]);
    return size;
};

var useElementTransition = function (_a) {
    var element = _a.element, trigger = _a.trigger, onTransitionEnd = _a.onTransitionEnd;
    useEffect(function () {
        if (!element)
            return;
        var handleTransitionEnd = function (event) {
            onTransitionEnd(event);
        };
        element.addEventListener("transitionend", handleTransitionEnd);
        return function () {
            element.removeEventListener("transitionend", handleTransitionEnd);
        };
    }, [trigger]);
};

// Hook
var useEventListener = function (eventName, handler) {
    // Create a ref that stores handler
    var savedHandler = useRef();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    useEffect(function () {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(function () {
        var element = window;
        // Make sure element supports addEventListener
        // On
        var isSupported = element && element.addEventListener;
        if (!isSupported)
            return;
        // Create event listener that calls handler function stored in ref
        var eventListener = function (event) { return savedHandler.current(event); };
        // Add event listener
        element.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return function () {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName] // Re-run if eventName or element changes
    );
};

var useIntersectionObserver = function (ref, rootMargin) {
    var _a = useState(false), isVisible = _a[0], setState = _a[1];
    useEffect(function () {
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setState(entry.isIntersecting);
        }, { rootMargin: rootMargin });
        ref.current && observer.observe(ref.current);
        return function () {
            if (ref === null || ref === void 0 ? void 0 : ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);
    return { isVisible: isVisible };
};

var useIsClient = function () {
    var _a = useState(false), isClient = _a[0], setIsClient = _a[1];
    useEffect(function () { return setIsClient(true); }, []);
    return isClient;
};

var useKeyListener = function (_a) {
    var key = _a.key, handler = _a.handler;
    useEffect(function () {
        var handleKeyDown = function (event) {
            if (event.key === key) {
                handler();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
};
var useEscKeyListener = function (handler) {
    useKeyListener({
        key: "Escape",
        handler: handler,
    });
};

var useLocation = function () {
    var _a = React.useState(), location = _a[0], setLocation = _a[1];
    useEffect(function () {
        setLocation(window.location);
    }, []);
    return location;
};

var getNodeSize = function (node) {
    return node.getBoundingClientRect();
};
var useNodeSize = function () {
    var _a = useState(), intObserver = _a[0], setIntObserver = _a[1];
    var _b = useState(), resObserver = _b[0], setResObserver = _b[1];
    var _c = useState(), mutObserver = _c[0], setMutObserver = _c[1];
    var _d = useState(), size = _d[0], setSize = _d[1];
    var ref = useRef();
    var updateSize = function () {
        setSize(getNodeSize(ref.current));
    };
    var setRef = useCallback(function (node) {
        if (node !== null) {
            ref.current = node;
            var intObs = new IntersectionObserver(function (mutationsList, o) {
                console.log();
                for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                    var mutation = mutationsList_1[_i];
                    if (mutation.isIntersecting) {
                        updateSize();
                        // o.disconnect()
                    }
                }
            });
            intObs.observe(node);
            setIntObserver(intObs);
            var resObs = new ResizeObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    entries_1[_i];
                    updateSize();
                }
            });
            resObs.observe(node);
            setResObserver(resObs);
            var mutObs = new MutationObserver(function (mutationList, observer) {
                // Use traditional 'for loops' for IE 11
                for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                    var mutation = mutationList_1[_i];
                    if (mutation.type === "attributes") {
                        updateSize();
                    }
                }
            });
            mutObs.observe(node, { attributes: true });
            setMutObserver(mutObs);
        }
        else {
            setIntObserver(undefined);
            setResObserver(undefined);
            setMutObserver(undefined);
        }
    }, []);
    useEffect(function () {
        return function () {
            if (intObserver) {
                intObserver.disconnect();
            }
        };
    }, [intObserver]);
    useEffect(function () {
        return function () {
            if (resObserver) {
                resObserver.disconnect();
            }
        };
    }, [resObserver]);
    useEffect(function () {
        return function () {
            if (mutObserver) {
                mutObserver.disconnect();
            }
        };
    }, [mutObserver]);
    return [size, setRef, ref];
};

/**
 * Hook used to detect clicks outside a component (or an escape key press). onTriggered function is triggered on `click` or escape `keyup` event.
 *
 */
function useOnClickOutside(_a) {
    var onTriggered = _a.onTriggered, allowAnyKey = _a.allowAnyKey, triggerKeys = _a.triggerKeys, excludedElements = _a.excludedElements;
    var ref = useRef(null);
    var onKeyboardEvent = function (e) {
        if (allowAnyKey) {
            onTriggered();
        }
        else if (triggerKeys) {
            if (triggerKeys.includes(e.key)) {
                onTriggered();
            }
        }
        else {
            if (e.key === "Escape") {
                onTriggered();
            }
        }
    };
    var onClick = function (e) {
        if (ref && ref.current) {
            if (!ref.current.contains(e.target) &&
                !(excludedElements === null || excludedElements === void 0 ? void 0 : excludedElements.some(function (x) { return x.contains(e.target); }))) {
                onTriggered();
            }
        }
    };
    return {
        ref: ref,
        onKeyboardEvent: onKeyboardEvent,
        onClick: onClick,
    };
}

var useOnUnmount = function (handler) {
    useEffect(function () {
        return function () {
            handler();
        };
    }, []);
};

var useQueryParameter = function (name) {
    var _a;
    var location = useLocation();
    var urlParams = deserializeQueryString((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : "");
    return urlParams === null || urlParams === void 0 ? void 0 : urlParams[name];
};

var useScrollDisabler = function (disableScroll) {
    var isClient = useIsClient();
    var _a = React.useState(false), activated = _a[0], setActivated = _a[1];
    var handleDisableScroll = function () {
        document.body.style.overflowY = "hidden";
    };
    var handleEnableScroll = function () {
        document.body.style.overflowY = "";
    };
    React.useEffect(function () {
        if (!isClient) {
            return;
        }
        if (disableScroll) {
            handleDisableScroll();
            setActivated(true);
        }
        else {
            if (activated) {
                handleEnableScroll();
            }
        }
    }, [disableScroll]);
};

var useVariableListener = function (value, _a) {
    var onChange = _a.onChange, _b = _a.skipFirst, skipFirst = _b === void 0 ? false : _b;
    var firstRender = useRef(true);
    useEffect(function () {
        if (skipFirst && firstRender.current) {
            firstRender.current = false;
            return;
        }
        onChange(value);
    }, [value]);
};

var DefaultLogger = /** @class */ (function () {
    function DefaultLogger(loggerName) {
        this.loggerName = loggerName;
    }
    DefaultLogger.prototype.debug = function (message, meta) {
        if (meta) {
            console.log("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), meta);
        }
        else {
            console.log("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message));
        }
    };
    DefaultLogger.prototype.info = function (message, meta) {
        if (meta) {
            console.info("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), meta);
        }
        else {
            console.info("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message));
        }
    };
    DefaultLogger.prototype.warn = function (message, meta) {
        if (meta) {
            console.warn("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), meta);
        }
        else {
            console.warn("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message));
        }
    };
    DefaultLogger.prototype.error = function (message, meta) {
        if (meta) {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), meta);
        }
        else {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message));
        }
    };
    DefaultLogger.prototype.fatal = function (message, meta) {
        if (meta) {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), meta);
        }
        else {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message));
        }
    };
    DefaultLogger.prototype.exception = function (message, error, meta) {
        if (meta) {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), error, meta);
        }
        else {
            console.error("".concat(this.loggerName ? "[".concat(this.loggerName, "] ") : "").concat(message), error);
        }
    };
    return DefaultLogger;
}());

var InternalLogger = /** @class */ (function () {
    function InternalLogger(settings, provider) {
        this.settings = settings;
        this.provider = provider;
    }
    InternalLogger.prototype.debug = function (message, meta) {
        if (this.settings.enabled && this.settings.level === LogLevel.Debug) {
            this.provider.debug(message, meta);
        }
    };
    InternalLogger.prototype.info = function (message, meta) {
        if (this.settings.enabled && this.settings.level <= LogLevel.Info) {
            this.provider.info(message, meta);
        }
    };
    InternalLogger.prototype.warn = function (message, meta) {
        if (this.settings.enabled && this.settings.level <= LogLevel.Warn) {
            this.provider.warn(message, meta);
        }
    };
    InternalLogger.prototype.error = function (message, meta) {
        if (this.settings.enabled && this.settings.level <= LogLevel.Error) {
            this.provider.error(message, meta);
        }
    };
    InternalLogger.prototype.fatal = function (message, meta) {
        if (this.settings.enabled && this.settings.level <= LogLevel.Fatal) {
            this.provider.fatal(message, meta);
        }
    };
    InternalLogger.prototype.exception = function (message, error, meta) {
        if (this.settings.enabled && this.settings.level <= LogLevel.Error) {
            this.provider.exception(message, error, meta);
        }
    };
    return InternalLogger;
}());
var getLogger = function (_a) {
    var settings = _a.settings, loggerName = _a.loggerName;
    return new InternalLogger(settings, new DefaultLogger(loggerName));
};
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.setLevel = function (level) {
        this.settings.level = level;
    };
    Log.enable = function () {
        this.settings.enabled = true;
    };
    Log.disable = function () {
        this.settings.enabled = false;
    };
    Log.getLogger = function (loggerName) {
        return getLogger({
            settings: this.settings,
            loggerName: loggerName,
        });
    };
    var _a;
    _a = Log;
    Log.settings = {
        enabled: true,
        level: LogLevel.Debug,
    };
    Log.root = getLogger({
        settings: _a.settings,
    });
    return Log;
}());

export { LocalStorageService, Log, LogLevel, ThemeStyles, buildStylesheet, buildUrl, classNames, completed, cssVar, deepMerge, deserializeQueryString, downloadBlob, empty, ensureTailingSlash, extendTailwindTheme, extractNumber, failure, faulted, formatFileSize, getColorVar, getColorVarContrast, getColorVarDark, getColorVarLight, getGradientColorVar, getQueryParameter, getResponsiveValue, getTextFontVar, getTextLetterSpacingVar, getTextLineHeightVar, getTextSizeVar, getTextWeightVar, getThemeColorVar, hashString, idle, insensitiveEquals, isClient, isFirst, isInt, isLast, isNullOrUndefined, isObject, jsonClone, jsonEquals, loading, makeAbsoluteUrl, newUuid, normalizePxSize, openUrlInNewWindow, parseObjectPosition, parseObjectPositionResponsive, range, removeNewLines, replaceAll, replacePlaceholders, running, serializeQueryString, setColorVar, setColorVarContrast, setColorVarDark, setColorVarLight, setCssVar, setThemeColorVar, success, toTitleCase, triggerCompleted, triggerFailed, triggered, trimChar, trimEnd, trimStart, truncateText, updateQueryParameters, useDebounce, useDebouncedCallback, useDebouncedValue, useDetectClickOutside, useDidUpdate, useElementSize, useElementTransition, useEscKeyListener, useEventListener, useIntersectionObserver, useIsClient, useKeyListener, useLocation, useNodeSize, useOnClickOutside, useOnUnmount, useOperation, useQueryParameter, useScrollDisabler, useVariableListener };
//# sourceMappingURL=index.js.map
